<template>
    <div class="paySuccess-w">
        <template v-if="$route.query.status == 'success'">
            <van-icon class="successIcon" name="checked" color="#06C160" size="1.3rem"/>
            <div class="successText">{{language_cut.successText}}</div>
            <van-button class="successButton" round type="primary" size="small" block @click="$router.push('/')">{{language_cut.goBack}}</van-button>
        </template>
        <template v-else-if="$route.query.status == 'fail'">
            <van-icon class="successIcon" name="clear" color="#EE1024" size="1.3rem"/>
            <div class="successText">{{language_cut.failText}}</div>
            <van-button class="successButton" round type="danger" size="small" loading-type="spinner" :loading="clickAliPayLoading" block @click="clickAliPay">{{language_cut.payAgain}}</van-button>
        </template>
        <template v-else>
            <van-icon class="successIcon" name="info" color="#1989FA" size="1.3rem"/>
            <div class="successText">{{language_cut.waitText}}</div>
            <van-button class="successButton" round type="info" size="small" loading-type="spinner" :loading="clickAliPayLoading" block @click="clickAliPay">{{language_cut.goBack}}</van-button>
        </template>
    </div>
</template>

<script>
    export default {
        name: "payStatus",
        data() {
            return {
                clickAliPayLoading: false,
                language_cut: {
                    successText: '支付成功',
                    failText: '支付失败',
                    waitText: '支付系统可能存在延迟，请稍后在【订单查询】页面查询支付状态',
                    goBack: '返回首页',
                    payAgain: '再次支付'
                }
            }
        },
        created() {
            this.language_cut_fun();
        },
        methods: {
            language_cut_fun(){     // 语言切换
                if(sessionStorage.language == 'en'){
                    this.language_cut = {
                        successText: 'Successful Payment',
                        failText: 'Payment Failed',
                        waitText: 'There may be a delay in the payment system, please check the payment status on the [Order Inquiry] page later',
                        goBack: 'Return to Home Page',
                        payAgain: 'Pay again'
                    }
                }else{
                    this.language_cut = {
                        successText: '支付成功',
                        failText: '支付失败',
                        waitText: '支付系统可能存在延迟，请稍后在【订单查询】页面查询支付状态',
                        goBack: '返回首页',
                        payAgain: '再次支付'
                    }
                }
            },
            clickAliPay() {
                let orderSn = this.$route.query.orderSn
                if (!orderSn) {
                    let msg = sessionStorage.language == 'ch' ? '数据异常，无法发起支付，请从订单查询处再次发起支付' : 'The data is abnormal, payment cannot be initiated. Please initiate payment again from the order inquiry'
                    this.$notify({ type: 'danger', message: msg});
                    return
                }
                if (!this.clickAliPayLoading) {
                    this.clickAliPayLoading = true
                    this.$service.aliPayPrepare({orderSn : orderSn}).then(res => {
                        this.clickAliPayLoading = false
                        if (res.code === 20000) {
                            window.location.href = res.data
                        } else {
                            this.$notify({ type: 'danger', message: res.data });
                        }
                    }).catch(() => {
                        let msg = sessionStorage.language == 'ch' ? '请求异常' : 'Request exception'
                        this.$notify({ type: 'danger', message: msg });
                    })
                }

            },
        }
    }
</script>

<style scoped lang="less">
    .paySuccess-w {
        height: 5rem;
        margin-left: 5%;
        width: 90%;
        text-align: center;
        .successIcon {
            position: relative;
            margin-top: 20%;
        }
        .successText {
            margin-top: 15px;
        }
        .successButton {
            margin-top: 20px;
        }
    }
</style>
